export default __webpack_public_path__ + "0d90affa43c8b69b11575fb17aeb9011.png";